import { ThreadParticipantsBody } from "@/components/contacts/ThreadParticipantsBody.tsx";
import { parseThreadId } from "@/components/threads/util.ts";
import { CanvasCenteredBody, CanvasModalCard } from "./CanvasModalCard.tsx";

/**
 * The canvas overlay for a thread's participant roster. Renders the shared
 * {@link ThreadParticipantsBody} into the generic {@link CanvasModalCard} shell,
 * so the facepile on a canvas page fills the canvas instead of opening the right
 * sidebar. Clicking a person drills onto the contact card from here, since the
 * body links each row and the stack's `push` boundary claims it.
 */
export const CanvasParticipantsModal = ({
  threadId,
  container,
  showBack,
  isFullscreen,
  onBack,
  onClose,
}: {
  /** The thread whose participants are presented, from the canvas URN's id. */
  threadId: string;
  /** The stack layer this modal portals into. */
  container: HTMLElement;
  /** Show the leading Back affordance (this layer sits above the stack root). */
  showBack: boolean;
  /** Whether the presented entity is shown fullscreen. */
  isFullscreen: boolean;
  /** Pop this layer. */
  onBack: () => void;
  /** Clear the whole stack. */
  onClose: () => void;
}) => {
  // The URN parser admits this type only with a numeric id, so this holds for
  // anything the stack routes here; parsing strictly covers a hand-written URN
  // and keeps the body's prop honestly typed rather than cast.
  const numericThreadId = parseThreadId(threadId);

  return (
    <CanvasModalCard
      title="People"
      container={container}
      showBack={showBack}
      isFullscreen={isFullscreen}
      onBack={onBack}
      onClose={onClose}
    >
      {numericThreadId !== undefined ? (
        <div className="px-4 py-4">
          <ThreadParticipantsBody threadId={numericThreadId} />
        </div>
      ) : (
        <CanvasCenteredBody>This thread can't be shown.</CanvasCenteredBody>
      )}
    </CanvasModalCard>
  );
};
